import { LegalDocumentPage } from '@/features/legal/ui/LegalDocumentPage'

export const TermsAndConditionsPage = () => <LegalDocumentPage documentId='terms' />

export const PrivacyPolicyPage = () => <LegalDocumentPage documentId='privacy' />

export const CookiePolicyPage = () => <LegalDocumentPage documentId='cookies' />

export const DataProcessingAgreementPage = () => <LegalDocumentPage documentId='dpa' />
